import { Helmet } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const ContactPage = () => {
  return (
    <div className="min-h-screen overflow-hidden">
      <Helmet>
        <title>Contact | Priya Pareek</title>
        <meta
          name="description"
          content="Get in touch with Priya Pareek for inquiries about visual art, design projects, or collaborations."
        />
      </Helmet>
      <Navbar />
      <Contact />
      <Footer />
    </div>
  );
};

export default ContactPage;